
////////////////////////
// Android WebView 85 //
////////////////////////

// https://dmitripavlutin.com/replace-all-string-occurrences-javascript/
try {
  'string'.replaceAll('t', 'z')
} catch (e) {
  String.prototype.replaceAll = function (search, replace) {
    return this.split(search).join(replace)
  }
}
